// extracted by mini-css-extract-plugin
module.exports = {"empty":"HB","pagination":"IB","disabled":"JB"};